/* eslint-disable */
/**
 * Add notification badge (pill) to favicon in browser tab
 */
class FaviconBadge {
  constructor(options) {
    Object.assign(
      this,
      {
        backgroundColor: '#f00',
        color: '#fff',
        size: 0.3,
        position: 'ne',
        radius: 6.1,
        // Favicon source (dafaults to the <link> icon href)
        src: '',
      },
      options,
    );
    this.canvas = document.createElement('canvas');
    this.src = this.src || (this.faviconEL && this.faviconEL.getAttribute('href'));
    this.ctx = this.canvas.getContext('2d');
  }

  faviconEL = document.querySelector('link[rel$=icon]');

  _drawIcon() {
    this.ctx.clearRect(0, 0, this.faviconSize, this.faviconSize);
    this.ctx.drawImage(this.img, 0, 0, this.faviconSize, this.faviconSize);
  }

  _drawShape() {
    const outerDiameter = this.radius * 1.8;
    const innerDiameter = this.radius * 1.5; // Adjust the inner diameter as needed
    const x = this.offset.x + this.badgeSize / 2;
    const y = this.offset.y + this.badgeSize / 2;

    // Draw the outer circle (white)
    this.ctx.beginPath();
    this.ctx.arc(x, y, outerDiameter, 0, 2 * Math.PI, false);
    this.ctx.fillStyle = '#fff'; // White color for the outer circle
    this.ctx.fill();
    this.ctx.closePath();

    // Draw the inner circle (red)
    this.ctx.beginPath();
    this.ctx.arc(x, y, innerDiameter, 0, 2 * Math.PI, false);
    this.ctx.fillStyle = this.backgroundColor; // Red color for the inner circle
    this.ctx.fill();
    this.ctx.closePath();
  }

  _drawFavicon() {
    if (this.faviconEL) {
      this.faviconEL.setAttribute('href', this.dataURL);
    }
  }

  _draw() {
    this._drawIcon();

    if (this._showBadge) {
      this._drawShape();
    }

    this._drawFavicon();
  }

  _setup() {
    this.faviconSize = this.img.naturalWidth;
    this.badgeSize = this.faviconSize * this.size;
    this.canvas.width = this.faviconSize;
    this.canvas.height = this.faviconSize;
    const sd = this.faviconSize - this.badgeSize;
    this.offset = {
      ne: { x: sd - 3, y: 0 },
    }[this.position];
  }

  // Public functions / methods:

  update() {
    this.img = new Image();
    this.img.addEventListener('load', () => {
      this._setup();
      this._draw();
    });
    this.img.src = this.src;
  }

  get dataURL() {
    return this.canvas.toDataURL();
  }

  get showBadge() {
    return this._showBadge;
  }

  set showBadge(val) {
    this._showBadge = val;
    this.update();
  }
}

export default FaviconBadge;
